import { useEffect } from "react";
import { UseFormReturn } from "react-hook-form";
import { DealProps } from "../DealConfig";

/**
 * A renewal has no tenancy coordination or design review fee, so both toggles
 * start off. The saved fees come from the state, not the form, so set both.
 * The user can still switch a toggle on by hand afterwards.
 */
export const useRenewalFeeToggles = (
  isRenewal: boolean,
  form: Pick<UseFormReturn<any>, "setValue">,
  setState: DealProps["setState"]
) => {
  useEffect(() => {
    if (!isRenewal) return;

    setState((prev) => ({
      ...prev,
      tenancyCoordinationFeeToggle: false,
      designReviewFeeToggle: false,
    }));
    form.setValue("tenancyCoordinationFeeToggle", false);
    form.setValue("designReviewFeeToggle", false);
  }, [isRenewal, form, setState]);
};
